import React from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const DrinkDialog = (props) => {
    const { select_drink, handleClose } = props;

    return (
        <React.Fragment>
            <Dialog fullWidth maxWidth="md" open={select_drink ? true : false} onClose={handleClose}>
                <DialogTitle sx={{ pr: 5 }}>
                    {select_drink.drink_name}
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            zIndex: 1,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box
                        noValidate
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            m: "auto",
                            width: "fit-content",
                        }}
                    >
                        <img src={select_drink.image_path} width="100%" />
                    </Box>
                    <DialogContentText>
                        {select_drink.drink_detail}
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default DrinkDialog;
